function save(sess, invoice) {
    const {Invoice} = sess;
    const invoiceItems = invoice.invoiceItems.map((invoiceItem => {
        return saveInvoiceItem(sess, invoiceItem);
    }));
    return Invoice.create({
        ...invoice,
        invoiceItems
    });
}

function remove(sess, id) {
    const {Invoice} = sess;
    if (!Invoice.idExists(id)) {
        throw new Error(`there is not any invoice with id: '${id}'`);
    }
    return Invoice.withId(id).delete();
}

function saveInvoiceItem(sess, item) {
    const {InvoiceItem} = sess;
    return InvoiceItem.create(item);
}

function removeInvoiceItem(sess, id) {
    const {InvoiceItem} = sess;
    if (!InvoiceItem.idExists(id)) {
        throw new Error(`there is not any invoiceItem with id: '${id}'`);
    }
    return InvoiceItem.withId(id).delete();
}

function addItem(sess, id, item) {

}

function removeItem(sess, id, itemId) {

}

function setDiscount(sess, id, discount) {

}

function removeDiscount(sess, id) {

}

export default {
    save,
    remove,
    addItem,
    removeItem,
    setDiscount,
    removeDiscount,
    saveInvoiceItem,
    removeInvoiceItem
}